import { render } from "./AppPhone.vue?vue&type=template&id=2bf89842"
import script from "./AppPhone.vue?vue&type=script&lang=js"
export * from "./AppPhone.vue?vue&type=script&lang=js"

import "./AppPhone.vue?vue&type=style&index=0&id=2bf89842&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__